import { graphql } from '../../../../graphql/generated';

export const DELETE_FORM_DOCUMENT_MUTATION = graphql(`
  mutation DeleteFormDocument($id: ID!) {
    deleteFormDocument(id: $id) {
      id
    }
  }
`);
